import { Component } from '@angular/core';

@Component({
  selector: 'app-purchases',
  standalone: true,
  imports: [],
  templateUrl: './purchases.component.html',
  styleUrl: './purchases.component.css'
})
export class PurchasesComponent {

}
